import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './LoginModal.css';

function LoginModal({ isOpen, onClose, message }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isLocked, setIsLocked] = useState(false);
  const [remainingAttempts, setRemainingAttempts] = useState(null);
  const { login } = useAuth();
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    setIsLocked(false);
    setRemainingAttempts(null);

    try {
      await login(email, password);
      onClose();
      setEmail('');
      setPassword('');
    } catch (err) {
      setError(err.message);
      setIsLocked(err.locked || false);
      setRemainingAttempts(err.remaining_attempts || null);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSignUp = () => {
    onClose();
    navigate('/login?signup=true');
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        <div className="modal-header">
          <h2>Најава потребна</h2>
          {message && <p className="modal-message">{message}</p>}
        </div>
        {error && (
          <div className={`alert ${isLocked ? 'alert-error' : 'alert-warning'}`}>
            {error}
            {remainingAttempts !== null && remainingAttempts > 0 && !isLocked && (
              <div style={{ marginTop: '8px', fontSize: '0.9em' }}>
                Остануваат {remainingAttempts} обиди пред блокирање.
              </div>
            )}
          </div>
        )}
        <form onSubmit={handleSubmit} className="modal-form">
          <div className="form-group">
            <label htmlFor="modal-email">Е-пошта</label>
            <input
              id="modal-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={isLocked || isLoading}
              placeholder="user@example.com"
            />
          </div>
          <div className="form-group">
            <label htmlFor="modal-password">Лозинка</label>
            <input
              id="modal-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={isLocked || isLoading}
              placeholder="Внесете лозинка"
            />
          </div>
          <div className="modal-actions">
            <button
              type="submit"
              className="button button-primary"
              disabled={isLocked || isLoading}
            >
              {isLoading ? 'Најавување...' : 'Најави се'}
            </button>
            <button
              type="button"
              className="button button-outline"
              onClick={handleSignUp}
            >
              Регистрирај се
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default LoginModal;
